module.exports = __webpack_public_path__ + "static/media/biscuitsCookies.c4186e50.webp";